import React from 'react';
import DishIngredient from './DishIngredient';
import DishSubcomponent from './DishSubcomponent';
import SimpleInput from '../form/SimpleInput';
import SVGClose from '../../svg/Close';

class DishComponent extends React.Component {
  state = {
    small: 1,
    medium: 2,
    large: 3
  };

  render() {
    const { component, index } = this.props;
    return (
      <div className="dish-component cms__section-body">
        <div className="row">
          <div className="row__item row__item--two-third">
            <div className="dish-input--pad-right">
              <SimpleInput
                type="text"
                name="name"
                placeholder="Component Name"
                className="simple-input simple-input--bold"
                value={component.name || ''}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="row__item row__item--third">
            <div className="row row--nowrap">
              <div className="row__item">
                <div className="dish-input--pad">
                  <SimpleInput
                    type="number"
                    name="small"
                    placeholder="s"
                    className="simple-input simple-input--min-padding"
                    value={this.state.small}
                    onChange={this.handleQuickChange}
                  />
                </div>
              </div>
              <div className="row__item">
                <div className="dish-input--pad">
                  <SimpleInput
                    type="number"
                    name="medium"
                    placeholder="m"
                    className="simple-input simple-input--min-padding"
                    value={this.state.medium}
                    onChange={this.handleQuickChange}
                  />
                </div>
              </div>
              <div className="row__item">
                <div className="dish-input--pad">
                  <SimpleInput
                    type="number"
                    name="large"
                    placeholder="l"
                    className="simple-input simple-input--min-padding"
                    value={this.state.large}
                    onChange={this.handleQuickChange}
                  />
                </div>
              </div>
              <div className="row__item row__item--align-center">
                <div
                  className="dish__close-btn"
                  onClick={() => this.props.deleteComponent(index)}
                >
                  <SVGClose />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="dish-ingredient__row">
          <div className="dish-ingredient__label dish-ingredient__col--name ">
            Friendly Name
          </div>
          <div className="dish-ingredient__label dish-ingredient__col--prep">
            Prep
          </div>
          <div className="dish-ingredient__label dish-ingredient__col--quantity">
            Measure
          </div>
          <div className="dish-ingredient__label dish-ingredient__col--measure"></div>
          <div className="dish-ingredient__label dish-ingredient__col--multiplier">
            S
          </div>
          <div className="dish-ingredient__label dish-ingredient__col--multiplier">
            M
          </div>
          <div className="dish-ingredient__label dish-ingredient__col--multiplier">
            L
          </div>
          <div className="dish-ingredient__label dish-ingredient__col--delete"></div>
        </div>

        {this.mapSubcomponents(component.components)}

        {this.mapIngredients(component.ingredients)}

        <div className="row dish-component__ctas">
          <div className="row__item row__item--half">
            <div
              className="btn btn--hollow-blue btn--full-width"
              onClick={this.openAddIngredientModal}
            >
              Add Ingredient
            </div>
          </div>
          <div className="row__item row__item--half">
            <div
              className="btn btn--hollow-blue btn--full-width"
              onClick={this.openAddSubcomponentModal}
              disabled={!component.ingredients}
            >
              Add Instructions
            </div>
          </div>
        </div>

        <SimpleInput
          type="text"
          name="instructions"
          placeholder="Add overall component instructions"
          value={component.instructions || ''}
          onChange={this.handleChange}
        />
      </div>
    );
  }

  mapIngredients = ingredients => {
    const { index, updateIngredient, deleteIngredient } = this.props;
    if (ingredients) {
      return ingredients.map((ingredient, key) => (
        <DishIngredient
          key={key}
          componentIndex={index}
          subcomponentIndex={-1}
          ingredientIndex={key}
          ingredient={ingredient}
          updateIngredient={updateIngredient}
          deleteIngredient={deleteIngredient}
        />
      ));
    }
  };

  mapSubcomponents = subcomponents => {
    const {
      index,
      updateIngredient,
      deleteIngredient,
      updateSubcomponent,
      deleteSubcomponent
    } = this.props;
    if (subcomponents) {
      return subcomponents.map((subcomponent, key) => (
        <DishSubcomponent
          key={key}
          index={key}
          componentIndex={index}
          subcomponent={subcomponent}
          updateSubcomponent={updateSubcomponent}
          deleteSubcomponent={deleteSubcomponent}
          updateIngredient={updateIngredient}
          deleteIngredient={deleteIngredient}
        />
      ));
    }
  };

  openAddIngredientModal = e => {
    e.preventDefault();
    this.props.openModal('add-ingredient', {
      activeComponent: this.props.index
    });
  };

  openAddSubcomponentModal = e => {
    e.preventDefault();
    this.props.openModal('add-subcomponent', {
      activeComponent: this.props.index
    });
  };

  handleChange = e => {
    const { name, value } = e.target;
    const component = {
      ...this.props.component,
      [name]: value
    };
    this.props.updateComponent(this.props.index, component);
  };

  handleQuickChange = e => {
    const { name, value } = e.target;
    const component = { ...this.props.component };
    const num = Number.parseInt(value, 10);

    if (Number.isInteger(num) && num >= 0) {
      if (component.ingredients)
        // loop + update ingredients
        component.ingredients = component.ingredients.map(ingredient => {
          ingredient.multiplier = { ...ingredient.multiplier, [name]: num };
          return ingredient;
        });

      if (component.components)
        // loop components
        component.components = component.components.map(comp => {
          // then loop  + update ingredients
          if (comp.ingredients)
            comp.ingredients = comp.ingredients.map(ingredient => {
              ingredient.multiplier = { ...ingredient.multiplier, [name]: num };
              return ingredient;
            });
          return comp;
        });

      this.props.updateComponent(this.props.index, component);
    }

    this.setState({ [name]: value });
  };
}

export default DishComponent;



// WEBPACK FOOTER //
// ./src/components/dish/DishComponent.js